import ARouterLinkConfig from "aloha-vue/src/ui/ARouterLinkConfig/ARouterLinkConfig";

import UIComponentMixin from "../UIComponentMixin";
import Targets from "../../../const/Targets";
import {
  gettext,
} from "../../../functions/utils";
import {
  get,
} from "lodash-es";

// @vue/component
export default {
  name: "UiRouterLinkConfig",
  components: {
    ARouterLinkConfig,
  },
  mixins: [
    UIComponentMixin,
  ],
  inject: {
    routerLinkConfigHelpTextParam: {
      default: undefined,
    },
    routerLinkConfigHelpTextQuery: {
      default: undefined,
    },
  },
  computed: {
    targetsLocal() {
      return this.options.targets || Targets;
    },
  },
  methods: {
    onChange({ model }) {
      this.onInput_mixin({ value: model });
    },

    keyLabelCallbackRoute({ item }) {
      const LABEL = get(item, "meta.label");
      if (LABEL) {
        return `${ gettext(LABEL) } <strong>${ item.path }</strong>`;
      }

      return `<strong>${ item.path }</strong>`;
    },
  },
};
